import {
    pushBingAdsUETEvent,
    trackFacebookContentDownloadConversions,
    trackFacebookConversions,
    trackLinkedIDownloadContentNoBarrierConversion,
    trackLinkedInDownloadContentConversion,
    trackLinkedInSignupConversion,
    trackLinkedInWebinarSignupConversion
} from 'helpers/3rdParty';
import {
    trackGoogleAdsContentDownloadConversion,
    trackGoogleAdsConversion,
    trackGoogleAdsUngatedContentDownloadConversion
} from 'helpers/GoogleAnalytics';

import { trackEvent, TrackingEvents } from './TrackingHelper';

export const handleSignupTracking = (data) => {
    //Apollo Meetings Track
    if (window.ApolloMeetings) {
        const lead = data.submissionValues;
        window.ApolloMeetings.initWidget({
            appId: '66a0d95532062501b2d9bd5b',
            schedulingLink: 'hij-8rp-n92'
        });
        window.ApolloMeetings.submit({ map: false, lead });
    }
    trackEvent(TrackingEvents.SIGN_UP);
    trackGoogleAdsConversion();
    pushBingAdsUETEvent('sign_up', 'engagement', 'try_salesscreen_form');
    trackFacebookConversions();
    trackLinkedInSignupConversion();
};

export const handleContentDownloadTracking = (contentTitle) => {
    pushBingAdsUETEvent('download_content', 'engagement', contentTitle);
    trackEvent(TrackingEvents.DOWNLOAD_CONTENT, { content: contentTitle });
    trackFacebookContentDownloadConversions(contentTitle);
    trackGoogleAdsContentDownloadConversion();
    trackLinkedInDownloadContentConversion();
};

export const handleUngatedContentDownloadTracking = (contentTitle, source) => {
    trackLinkedIDownloadContentNoBarrierConversion();
    trackEvent(TrackingEvents.DOWNLOAD_CONTENT, {
        content: contentTitle,
        click_source: source
    });
    trackFacebookContentDownloadConversions(contentTitle);
    trackGoogleAdsUngatedContentDownloadConversion();
};

export const handleWebinarSignupTracking = (webinarId) => {
    pushBingAdsUETEvent('webinar_signup', 'engagement', webinarId);
    trackEvent(TrackingEvents.WEBINAR_SIGN_UP, { webinarId: webinarId });
    trackLinkedInWebinarSignupConversion();
};
